const ReadingTime = {
    init() : void {
        const $containerTarget = document.querySelector<HTMLElement>('.single-post .post-content-section .container');

        if ($containerTarget) {
            let str = $containerTarget.innerText;
            str = str.replace(/(^\s*)|(\s*$)/gi, '');
            str = str.replace(/[ ]{2,}/gi, ' ');
            str = str.replace(/\n /, '\n');

            const count = str.split(' ').length;
            const wordsPerMin = 300;
            const calcul = Math.ceil(count / wordsPerMin);

            const $readingTimeHeader = document.querySelector<HTMLElement>('.js-reading-time-header');
            const $readingTimeContent = $containerTarget.querySelector<HTMLElement>('.js-reading-time-sidebar');

            if ($readingTimeHeader) {
                if (calcul > 1) {
                    $readingTimeHeader.innerText = calcul + ' minutes';
                } else {
                    $readingTimeHeader.innerText = '< ' + calcul + ' minute';
                }
            }

            if ($readingTimeContent) {
                if (calcul > 1) {
                    $readingTimeContent.innerText = calcul + ' min';
                } else {
                    $readingTimeContent.innerText = '< ' + calcul + ' min';
                }
            }
        }
    },
};

export default ReadingTime;
